export default __webpack_public_path__ + "static/media/logo.3fbc4b6e.png";